Ext.define('SA.view.color.RecentRow', {
    alias: 'widget.recent-row',
    extend: 'SA.view.SimpleContainer',

    bubbleEvents: ['select:transparentColor'],
    cls: 'sa-recent-row',

    items: [
        {
            xtype: 'component',
            cls: 'sa-recent-row-transparent-btn',
            hidden: true,
            itemId: 'transparentBtn',
            margin: '0 18 0 6',
            overCls: 'sa-recent-row-transparent-btn-over',
            renderTpl: '<span class="sa-recent-row-transparent-btn-inner" title="Make transparent"></span>',

            listeners: {
               el: {
                   click() {
                       Ext.getCmp(this.id).up('recent-row').onTransparentBtnClick();
                   }
               }
            }
        }, {
            xtype: 'recent-colors',

            listeners: {
                'select:color': function(view, color) {
                    view.up('recent-row').onRecentColorClick(color);
                }
            }
        }
    ],

    initComponent() {
        this.callParent();

        this.transparentBtn = this.down('#transparentBtn');
        this.recents = this.down('recent-colors');
    },

    addRecentColor(color) {
        this.recents.addColor(color);
    },

    onRecentColorClick(color) {
        this.fireEvent('select:recentColor', color);
    },

    onTransparentBtnClick() {
        this.fireEvent('select:transparentColor');
    },

    setAllowTransparent(allow) {
        this.transparentBtn.setVisible(allow);
    }
});
